import React, { useState, useEffect, useRef, type CSSProperties } from 'react';
import classNames from 'classnames';
import { Tooltip } from '@fiverr-private/tooltip';
import { Text } from '@fiverr-private/typography';
import { DEFAULT_LINES, DEFAULT_TAG } from './constants';

import './index.scss';

interface EllipsisProps {
    maxLines?: number;
    textClassName?: string;
    text?: string;
}

export const Ellipsis = ({ text = '', textClassName = '', maxLines = DEFAULT_LINES }: EllipsisProps) => {
    const textRef = useRef<HTMLParagraphElement>(null);
    const [hasEllipsis, setHasEllipsis] = useState(false);
    const style: CSSProperties = { '--lines': maxLines };

    useEffect(() => {
        if (textRef.current && textRef.current.scrollHeight > textRef.current.clientHeight) {
            setHasEllipsis(true);
        }
    }, []);

    const Wrapper = hasEllipsis ? Tooltip : DEFAULT_TAG;

    return (
        <Wrapper content={text} className="ellipsis-tooltip">
            <Text as="p" style={style} ref={textRef} className={classNames('ellipsis-text', textClassName)}>
                {text}
            </Text>
        </Wrapper>
    );
};
